import React, { Component } from "react";
import getContract from "../services/contract";
import { ethers } from "ethers";
import withWrapper from '../helpers/withWrapper'
import getWallet from '../services/wallet';
import { getLastActivities, getLastDayCount, getLastDayIncome } from '../services/activities';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class Login extends Component {
  state = {
    id: "",
    userAddress: "",
    isConnected: false,
    lastId: 0,
    activities: [],
    totalMembers: 0,
    allTotalValue: 0,
    totalValue: 0,
  };

  connectWallet = async () => {
    const tronweb = await getWallet();
    if (tronweb && tronweb.defaultAddress != false) {
      const browserAddress = tronweb.defaultAddress.base58;
      this.setState({ userAddress: browserAddress, isConnected: true });
    } else {
      alert("Wallet not connected");
    }
  };

  initialize = async () => {
    // alert("i am here now!")
    await this.connectWallet();
    const contract = await getContract();
    console.log("here")
    // alert("contract initizlied")
    if(!contract) {
      alert('Connect Wallet');
      // return;
    }

      const totalMembers = ethers.BigNumber.from(
        await contract.lastIDCount().call()
      ).toNumber();
      let totalInvestedBN = await contract.totalValueInvested().call();
      let allTotalValue = ethers.BigNumber.from(
        totalInvestedBN.div(ethers.BigNumber.from("1000000"))
      ).toNumber();

      this.setState({ totalMembers, allTotalValue });

      const lastId = await getLastDayCount();
      const totalValue = await getLastDayIncome();
      this.setState({lastId, totalValue})
      
  }

  async componentDidMount() {
    try {
      this.initialize();
      const promise = getLastActivities();
      const activities = await toast.promise(promise, {
        pending: "Fetching recent transactions",
        success: "Transactions loaded",
        error: "Error fetching data",
      });
      this.setState({activities});
    } catch (error) {
      alert(error)
      console.log(error);
    }
  }

  handleViewClick = async () => {
    try {
      const contract = await getContract();
      const id = this.state.id;
      const lastId = ethers.BigNumber.from(
        await contract.lastIDCount().call()
      ).toNumber();
      if (lastId < id) {
        alert(`User Id ${id} not found`);
        return;
      }
      this.props.router.navigate("/dashboard/" + id);
    } catch (error) {
      console.log(error.message);
    }
  };

  handleLogin = async () => {
    const tronweb = await getWallet();
    if (tronweb && tronweb.defaultAddress.base58 !== false) {
      const browserAddress = tronweb.defaultAddress.base58;
      const contract = await getContract();
      const id = ethers.BigNumber.from(
        await contract.getIdByAddress(browserAddress).call()
      ).toNumber();
      if (id === 0) {
        alert(
          "No Id found with your connected wallet"
        );
        return;
      }
      this.props.router.navigate("/dashboard/" + id);
    }
  };

  render() {
    return (
      <>
        <header className="header">
          <div id="__next1">
            <ToastContainer position="bottom-right" />
            <div className="flex relative bg-main-bg flex-col items-center justify-center w-full min-h-screen text-white-500 px-10 sm:px-0 overflow-hidden pt-16">
              <header className="fixed top-0 w-full pb-2.5 pt-2.5 px-10 z-30 bg-gray-900 sm:px-5 lg:border-b lg:border-white-100">
                <nav className="z-10 w-full max-w-desktop-preview-bar m-auto header-border-b">
                  <div className="flex items-center justify-between">
                    <a href="/" className="header-link">
                      <img
                        src="/images/logo-text.png"
                        style={{width: "180px !important"}}
                        className="light w-20"
                        alt=""
                      />
                      <img
                        src="/images/logo-text.png"
                        style={{width: "180px !important"}}
                        className="dark w-20"
                        alt=""
                      />
                    </a>
                    <div className="flex justify-end items-center ml-auto">
                    {this.state.userAddress == '' || this.state.userAddress == 'TXrwicLhxinpPP3xLhNqyKZa3nmV3zfNwK' ? 
                    <button onClick={this.connectWallet}
                      className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray text-white font-normal rounded items-center"
                      id="connectWallet"
                    >
                      Connect wallet
                    </button> : 
                    <div className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray text-white font-normal rounded items-center">
                      {`${this.state.userAddress.substr(0, 4)}...${this.state.userAddress.substr(-4)}`}
                    </div>
                    }
                    </div>
                  </div>
                </nav>
                <div className="hidden justify-start items-start bg-main-bg pb-5 pt-7.5 transition duration-500 ease-in-out bg-main-bg absolute top-0 left-0 z-20 inset-0 h-screen w-screen z-999999 -translate-x-120% lg:flex flex-col lg:py-2.5">
                  <div
                    className="w-full flex flex-col flex-1"
                    style={{ height: "757px" }}
                  >
                    <div className="flex justify-between items-center w-full px-10 sm:px-5">
                      <a href="/">
                        <svg
                          className="block mr-2.5"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="163"
                          height="30"
                          viewBox="0 0 679 136"
                        >
                          <image
                            y="11"
                            width="676"
                            height="125"
                            xmlnsXlink="data:img/png;base64,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"
                          ></image>
                          <image
                            x="74"
                            width="72"
                            height="48"
                            xmlnsXlink="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAwCAYAAACynDzrAAAU6UlEQVRogd1aCZRU1bXd975Xr+YeqnpuoCdmmkFEaBQQGb8ifAZJRDSSCMZ8EhL9GhHN8KOoyI9fSYxCxIggihEHRCIQZpRJQBsEmrFHeqLpsaq7qt57N+veququrq5uutGVZP2zVq16wx33PWefc899ZGVmX4DAL4wBhLT8w/+K8fvrFdEer+tvkzHEekEelMGmRRN9RBTVJAt06ADcTIILBI2Mqo2MHNNBdlFggwz9OGnuniDQYPMYm4WFXYTOJWwOhI8lvG5Yc6LcPxEgow90EQFb7CCaI45qiCYaZAJozN8PL8qB8jCKBkbgYhR1jDI3o/tVkNclsHcNgPf/HUCMscFe0HeiiNYvmapwEE288iFskIH+KBgMAUVpAoGbEdQxCbVMKnAx+hrAXpXBauk/ASBpamxc6xfBTkMA+jaiEzJbBf2oG/Wlpks+WKkugNHQ0n6r7nkdEPHj5SQAVsoQS3XEEC3GCn0CA/mRBzTGB3KSErjaHWPYXMIBavvwnwyQCvJfFHgzXfIaUyVVLJLaTovhT70hz7QAoBysKKpzDbTaCBsDgvlNjEZ7QXIlAneblv+dAVJBFhgI+0MvySs5iQ5vQCs6K4wRSBEsSBdmSWChOmKJZo6i+mgAC1yQ6jUOFMeznbm0wqKTANFrjZcFO+jCTydksgFsVS/Ja+Ar7glwTXvwkJD/4LVCWJt3VGgWEUTuZURoo53oyKTemJ7U84qd6Ac8wNCuLMS15JoAdVU0hhsJYx/2krzg7tvDWgbbHtWzkP/gtR7yjARMs55RqKx1vSBQTqKhj+S5IZWq+xnwW+07Aum7BshKwNb2krxmG9XFwMMJGNdhttxmfIzACAYrYW3qc6D8WsqQJvnMvSTvbxSi7/Yy9PiW8+kAIO4Wu/AjjMHH8FqapPbjau8NaE6o1rCw/6CETzjSvYXoUIguwIocGkBwE9fYGMq1yXtrDNGOeEFGXQ8wQYkMEOn6zwMyJ5Gq98YRrZWptCehIISXDb+nAZML5xZ+J4VoUNAs+eIoAHpJvoQ4qu30MvJgoOh3BFAXEdJBelgJW55GVbHCNUxC0BBIOyR8LS0KlUhgB0FrZGJr0ioO9HOWv5cs6jXEUXWlD2Tp9bBSW4C6aFp+dWEvZlBvqiYGxwRAhsB6snZIuDMghE44XDi/CY4jgInoMIVwU7CtYPyUSb08yHzcA/In7iCvH6AuunP+8wHTkqk2y0KYgIQJ16t1Kea5lkTWNgYDmCBuGuL1QsvQgCbx+j0lH/eqP9GBd68PINb1n87gMBL2x1Tqa47O+EBjSIt77wxMHZWJ5AVZgFBIoL9IMRbXLr7ZVUMC1CyZb14wAyAbQUiqz+WeFDFgDBG5U6NsRxjD45nU212NsOkMSme2uR2VieQFI9WJdG/gni8AIl9AK3RkSj7kacoM2edLprKUrXm9UWpTEySDIVoymXw86xLazreJg/pGEf2XVqK3UW8+OCPpGJpI6xEpTgp/RsLIXmqnngLWDE6wvIdQGBpqYW+oJt76hpGzP9tscVVUzFbs9h/bunXb7KmpiQ0fF71eqlAZPuSm1R7XBOGJ5FvJdWhNONFznZXBRCpEDeEcOVBSD+GloBZ4NB3lvYfAaLNBMimIG9Bfypg4Yd1df/vkVVd5uTEmK3OSrmlPA0gM9i9NdcR1DpEQ0RgeiiXavGTh1ltzTfjqaxG0Reqk6bUnJJBUq4UElRHhwThhNzEKNygMYdG2z+cDqauBV1ZgGz8JI1esgKIY0P3WMUibME6yJSUR2WJJGvTAD6efWLM2VpLllwmhAl+yMqtvV8cX7WP44ga5qX+4Ww3XDE5wJbqMJKo2l+OmV6NLwjWTsHrh/+ESfK4GAOKaYSOaWKQGRtHECLjJWwLmLQVaKbc6hMetPnYMhnGTMGfH1ogT+2jufTi9fl0/c7TDZnEmDgLYe13mIAZMj6NafylE3UPeNQtvuEanzRomSBMMpbqMxrA9WiQzaqfvwMSBKKI1hxOqyBUxJFIVTpFm80t9kw+VhSWIionC6L9tRdJPfgaL09GmXd3nX8DUYcPYzYuXvPsff151RPM2Pc8dIe2ae+d7Lqx0ioF1LLzhCiZDCZTkg+arXKbJSCBqV9eluQ0EwNcCwASBtxO/iRVddcFdXAKFAFXWGBjvm4/8o8dhtVkw8Y8vYeKf/tCm3f2/+R/xf9PDPye3Prd0cGPlFVBJupnnimnXdhXkJzJhRhuJTM3hWtEUmAQN3F/UFfSUvF0OImkgGAzVLGNIpG5g/mhI1TTYH3kCbOpMnM/LR/KEiRj7ygr0e/pZSAYFhFJY4tpyrmQxNV9f2roNHy986N264qLzTNN4RtHZ2XEaVJBXk6maHEV01DNJkGPooMO3kpW6JNxkNNVEoqtal9Fd8qGruRqNUBCvB7JIxlFxX1RaxbcPMFnMKCwph7fiChxmGeZps5Cz9GlUNDQh484pcPTMQuqI4SBS+2ySMHAQZHMQJILet9+RFD8we+GVk6f6ypHSke3IMDD0Twp4Lq7cdYyCa1MoSSPEDUNokH8LwtU/lqohDNFSJxzkcMJuVBmqoxJhOnMCSd0S4dYpbD/4EUo//RjWosuIXvQ4LERDwerX4ThzRnDU+OXPddpTmmJjmq9je2ZCNhriyg4fsYOQMrl5RqEjjCA6MDOOqMagefDEVQWTRNYwWCWUl2iATPmWgztdfnRkDRTknKEFIAyCQEW6qyVlIfm8oBKFSmUYVQ/Mo8Yi4+GHceZnP4XR58bw++agYcZ0fDDxdjz81GKhAcXfu7slQCV+R6CrKpquXoUlIaHVpKpOnYazf782Ey378ijemjS5zFVbnZLSPZNF2M23+1vgpJpwsVW6JLwGP9/irjUIEE891AaaFJtWkY+m4jm/jg6ch3Gyrr5QANrkbuYWj1eDt+oKjMQP2CVqwdnCSjSVl8Gu+3Dl0BfInvcDDFj/Dq4mZ8AYF4/McbdizsF9zebRbdAAxA/MbjUd7qFOrFkHzeNpflbxVS6K9u6PqAgJgwfhgf374nLuf2AJCG3HMNuQM8tRoEcHB88T6hW6LKLWUB4KBnBBbYoPeKtyXRZhf35lLWRdQzmT4Vz8JEobdajV1eKQsJQquJLZH5fy8qFXVYIOvwXZb7+LukHDUepWkTLsJtFWv6lT8J+f74UtNUWcTHQbPiziFILCwUu+6UYcfH558+FhY/VV9Jo+TVzXFRXj/KdbcPnAQXFPDQauWfLQhQ89o0RFrWw/km7lkshLVqL3d1C/BvBgjHsonbROrnCzcUOCg+ighIn9UIkqobywAFHQ0ZgzFpe/PAboOiZv+hjWcRNwfvc+NJ7Kg/W28bjtww9QQ2S4a+vQe8ECZM+ajrR75iJm2gwMuu8eEMm/cTHZ7aCyjHAJngCH79Cj09P9J7y6DlNsLKJ6dIcxyi7eeevq4LlaDVv3bjA7YkWZjdNm4tiKV0ZD10/6I+mO2UxhQFUqVW1OqjZbIJ98OOHy+4uaAn6i4fF4UF9ZhWpHEjLvn4dza9dizO+Xw6MzSJ4m9Js7R7jdq5fLcfiXjyH7xw+i22h/+tjt9cGiGDocVCThbvnMe+8jbfx4WBLaLjxTVZAIwIZL/t93YPPceUsVm/WpjgFiul3XtNvUJs/G/jGKzN0qz/dy7dBZC8kGhcc8Z1VFaJ8pLh72rEzUHD2KCatXwt6zl/8YOTGhbTeMCe2nlDTfuysrYU1oW7ZlaLpfU8K0pWjvPhTu2oM+s2YgLntAp4A9v2kzsu68A7mvv4HSI0e17mNGSQeeeb5QU31prQAilBgbr1zxSIoRSnQUfC7XJ4RKAwx2W0a32jK4vBoSFQqPQYGZU42itPoogJ9Z5WlGf4Srabhr0weISu8BT3U1otPSQhGJeNoZFF314cDSZRj55OKIpsSlYMcuGGxWpIwY3uZdQ2kp8rfvQJ9ZM2GwWiLW13w+ngMS139I6V43bOHCitw33+xZc/78zQAyHb367GG6XtyKpDWv7+7MKXfkKlH2n9cVFMDRq9eIbqNvyRj+6MPQEpKhDhmGamcSKqCgVDcIklYCUa4JDLVM5jxUxzXFZLWisaIcpqgoQZTHX3kN7ooK0Y+rvEKstAC1sRGXtm1v5WWobEDCkMHw1tW3CyIxGlBXVBTxnS05GX1nz4oYHHLN89Y3IPfPq7HzkcfONV69ih6jRtuOrvjjQqM9GjHpmV/HZvZ8m2l6MYLpDqZr4Fk1tdF9PqZn5t1T1ryxoPTQkduTc4b3GvficuLs2xeVlyvQ765ZUPpnQ3HGQenVG8qJ4yjxAlFGGS5G+FbitEQwh2lqlaNP70E5TzxuJJRAsdpQX1KCypOnkDhkMGSTCfnbdqCuuIjnZFDy+QFcPnQYyTe1eKSYzAwYLBahidwlR6entZqoKSYGzt69ISmRc/DcG0XSvtKDh7Dp7rnInHIHPvvFopXnNnzwmu7xaj63e5nm8dipJH3qXwG/hnOA+hos5tnRael9CKWOwt171JScEbeOef6ZbgkDs0nBrt1IGJgNa1oPFO7ai+z770X3CRPgq6/HyXXr0Zg9FO6aOhQz4wkAt1CJnPNU1+YPXbTw0aQbhzYPzNmvL6wJ8VDsdkHOScOGouLrE8KjxPXvh+oLFwV4zROUJMExvGxFbi5OvbUeKTnDmwGRjcZ2wQmV2vwCAeblQ1+i5PPPEZ2ZgV1Lniipzy9yKwbTANXtfsjX2PiebDbzvraJPkPMn6zK6nubbLFsyLzzjnhus2anQ0SfsT2zRIHKk9+IyRXt3oPGK1Xo+/3Z4nlDaRn2P/cCKg8dRk3Flc8MlMyhBDWax9Oj94zp525d9qzic7lgjnP6CZW2VXe/WRFIxmtPNO/9D4VL6HPXzGuWDYq3vh5rhg73LDh32vjhzNns0rbtF3uMHZt15cTJzarbfZ8xOnoEY+wQz8wEP7IKgtOcWpkaG5ffVFvzcsHO3bXOvr3HZ0yeRM0OBydofL1qNRKyB8DkiIVitwkTqMo7KwgwdWQOet4+GUf+7yXUnj8zQyJSoWIxm3RVe8veo7uyZ8mTp9InTujB+eDsBx8JoubaUvF1Lgp27BA8EJ2RDip37sCTL5jBbBFj6UgKduzS9zy+ZKPBYulfW1iEU2vfXmxJSJx0cs3aC0abdWDVqTPHTbExb0qKUgpCLoikA0I+9wlzHtKdjrhfWBMSPhry0ILpWVOn0GA6gLtaPpnSw0fQffQtMFitopGS/V9A11TEZ/tDeq4ZKTcNHyQZjQ/Wl1xeKZuMf7988OBzkmwYdtvy50X4a4yOxql3NiD15pGCVzSvD4eWLUf/e+7utDZwkxPgMIa6khK/qRKCS1u3w56SIhZhz+InUVtQSM6+v/GevPf/uqnq9JmpTNV+euGTzYMNFtsPqMFQqthsp8FYdSgoHQFEVmb2mabY7KmyxRybNn7s0tHP/A6Fe/ZCVozC5n3uRlz4dAvSxo8T5hd00bqmiUFzuXr2HPYt+dWa0iNfzuPkyDQts/89c06Z4hwGe0oK5WbJ2+FehXMHF+4UxHUnswm8P93nE55w/ZjxmLt/F4wxMVidPeTYkAXzh+a+vvqvrtLy45LZ+JjZEWfTNTXVW99Qa46N8Wo+n0xlg9o6T4DW3y52YGJ5PpcrNyVn+CM5ix/rw1eG267W5BEmISkGAYA1MRGyySj45NJnW5G34X1oqopzH3+Ct6ZOebE+P3+RxeHURSeU3lh78aJ+cu26d3vfNXOS8CaBML9ZI/izToDjqW+AbFR4EKfu/9Vv3f3u/p6y+8kltRVHv1JsKcmkcPuOO4r27beCsedMDsdG2WR+gxBcJlSqkU3GEjF3KoUkGtpqTUcaJE2NcY62d+9+eshDD/a3piRDsdlQduw40saNFS6WxykJgwaiLj8feRs/FGYS27MnbClJwlzsKcnoPXFyqkFRllSfO59BJWkHgLM+l2uTNSFx1E2/WDRxy7wH0FByGRmTJ4r2NK+3lQfiC8JNle+1yo4eQ9GevWJXfvIva7D53nkrotPTh3/x9LNlJYcP1FgTk2Nq8s7fX3vxQu6FLVt1Kkl/JpL0jmw0VvjBoPzg7zBAyiKC0mWAnPEGtanpxInVb74MicwzRceg/OhRpIzMwal176CptlbEJFyDzn+8GbUFBUgaegPMTicsCfFCzb9auaq+8Wr1VtflsgpCpc/5tizgpr/vqasfUXLg4H5fg2vfwB/NG7T53nmC32KzslD5da7YlW+ZN7+m/NhxNX3CeGXno7/EoeeXPWmw2nK++N3Sam9t7YSLW7Y4dZ/6pS059aW8De/1szjjnjLYbDspsJYaDE1UkiNMuh1QuggQb/mC5vVeMMc5kxKyB+KLZcswY4P/fP/Stm2YvOrV5sJjnv0dvnn7nVb8w8VVWtZYcvDQZ0abfQNr2VJzIDblrn6j3BIf/3JDWdnNexY/NefMexvKVZersmj3HtuFT/+288Hzp+fn79i1yVVZ+rpkNO5tKC6BLSn52V3//djn9tRuI81xVq51iwxms8xUTY1OT89hPAdNCGgn4qBvK5ykg028b3I4Znkb6jD/9EnxgMcpUoBUw6WpphaHnnuB1RUWEh7rFO7cA7XJ/ThAXghdEf+mknJzVeouF/86Ji1jfdPVKqfX7TplMFt8KTkjTlV8lbvCYDG/UJN/aa49pVs2NchPsBDCFKveKjcb/nF4JOINrdA6GdwVkg49OFzqLq84NGj+D98c/ugjsYde+F+Mf/lF8aKppkZEo1y4F+GT1jxerOrd7xx0LJKMhipLfEIxobS0GcdQVW3nS33OO/UlJb3tqanVTGeV/Eyp5TA9DIB/EUChCbOdktFYDEIe+fL3L+l5n21+0V1cPipryu1YmzMa7opKb8LgQdIb2Tfkf7Nuvaf8+Fc2Y1S0k8rSYsVmO0MIaWg9+448FGkGTrHbq/gRe0sdEqE+ifDh4rV45bvhoBaAGOO84qu5eMmheTy/jk7t8ZfK3NyY+qLinOK9+2oubd/es3DPvoyGy6WM6dqoqm9Ov6Vr6itUkioDH8Z3MIE2LyPft5rHvwdALSbW6iM/fyFdVU1NV6/+1BIfXwDgr+6KSlhTkqYwTd8Bxpo6/E6jQxOLdNgT+jiCCf0rTAzAPwCg60mk2wr2mQAAAABJRU5ErkJggg=="
                          ></image>
                        </svg>
                      </a>
                      <button className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-0 py-0 bg-black-light rounded-full w-10 h-10 hover:bg-line-gray active:bg-active-gray hidden lg:flex flex-col">
                        <span className="w-4 border-t border-white -mb-px rotate-45"></span>
                        <span className="w-4 border-t border-white -rotate-45"></span>
                      </button>
                    </div>
                    <div className="w-full h-full pl-10 pr-7.5 lg:pr-0 lg:pl-10 sm:pl-5 overflow-auto">
                      <div className="flex flex-1 flex-col h-full w-full overflow-y-auto space-y-2.5 lg:space-y-0">
                        <div className="flex flex-1 flex-col w-full h-full overflow-y-auto space-y-2.5 lg:space-y-0 lg:mb-5">
                          <a href="/dashboard">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 24 24"
                                  stroke="#fff"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 4H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM19 4h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM9 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM19 14h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Dashboard
                                </span>
                              </div>
                            </button>
                          </a>
                          <a href="/partners">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  stroke="#fff"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 7.333A2.667 2.667 0 1 0 6 2a2.667 2.667 0 0 0 0 5.333ZM2 14v-1.333A2.667 2.667 0 0 1 4.667 10h2.666A2.667 2.667 0 0 1 10 12.667V14M10.667 2.086a2.667 2.667 0 0 1 0 5.167M14 14v-1.333a2.667 2.667 0 0 0-2-2.567"
                                    strokeWidth="1.333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Partners
                                </span>
                              </div>
                            </button>
                          </a>
                          <a href="/stats">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 24 24"
                                  stroke="#fff"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16 12h5m-9-9v5-5ZM8.929 14.582 5.5 17.5M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Stats
                                </span>
                              </div>
                            </button>
                          </a>
                          <a href="/targets">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  stroke="#fff"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Targets
                                </span>
                                <span className="absolute top-1 right-1.5 text-orange text-sm lg:bg-orange-200 lg:px-2.5 lg:py-1 lg:rounded lg:top-1/2 lg:-translate-y-1/2 lg:right-5">
                                  Beta
                                </span>
                              </div>
                            </button>
                          </a>
                          <a href="/information">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 24 24"
                                  stroke="#fff"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13 7a2 2 0 0 1 2 2v12l-5-3-5 3V9a2 2 0 0 1 2-2h6Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M9.265 4A2 2 0 0 1 11 3h6a2 2 0 0 1 2 2v12l-1-.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Information
                                </span>
                              </div>
                            </button>
                          </a>
                          <a href="/tbots">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 24 24"
                                  stroke="#fff"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="m15 10-4 4 6 6 4-16-18 7 4 2 2 6 3-4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Telegram bots
                                </span>
                              </div>
                            </button>
                          </a>
                          <a href="/messages">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="m3 20 1.3-3.9c-1.124-1.662-1.53-3.63-1.144-5.538.386-1.908 1.54-3.626 3.244-4.836 1.704-1.21 3.845-1.827 6.024-1.739 2.179.089 4.248.877 5.821 2.22 1.574 1.342 2.546 3.147 2.735 5.078.19 1.931-.417 3.858-1.706 5.422-1.29 1.564-3.173 2.659-5.302 3.08-2.13.422-4.358.142-6.272-.787L3 20"
                                    stroke="#fff"
                                    strokeOpacity=".5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                  <path
                                    d="M12 12v.01M8 12v.01M16 12v.01"
                                    stroke="#fff"
                                    strokeOpacity=".5"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Messages
                                </span>
                              </div>
                            </button>
                          </a>
                          <div className="hidden lg:block" href="undefined">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent false lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  stroke="#fff"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.333 14.167a5.833 5.833 0 1 0 0-11.667 5.833 5.833 0 0 0 0 11.667ZM17.5 17.5l-5-5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 false">
                                  Red Rhino Account search
                                </span>
                              </div>
                              <svg
                                className="stroke-current text-white-500 hidden lg:flex"
                                width="8"
                                height="14"
                                stroke="#fff"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="m1 13 6-6M1 1l6 6"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </button>
                          </div>
                          <a className="hidden lg:block" href="/">
                            <button className="relative w-full flex items-center px-2.5 py-2 rounded-xl cursor-pointer undefined hover:bg-black-light lg:hover:bg-transparent bg-black-light lg:bg-transparent lg:border-b lg:border-white-300 lg:rounded-none lg:pl-0 lg:pr-5 lg:py-5 lg:justify-between">
                              <div className="flex items-center text-left">
                                <svg
                                  className="w-6 h-6 stroke-current text-white-500 lg:w-5 lg:h-5"
                                  width="24"
                                  height="24"
                                  stroke="#fff"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2M7 12h14m0 0-3-3m3 3-3 3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></path>
                                </svg>
                                <span className="text-white-500 text-base  ml-5 text-white-900">
                                  Log out
                                </span>
                              </div>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="w-full lg:px-5 lg:pb-7.5">
                      <a target="_blank" href="https://oldRRN.redrhino.io">
                        <button className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-light-purple hover:bg-hover-purple active:bg-active-purple bg-purple rounded-mini px-3 w-full justify-between mb-2.5 lg:mb-0">
                          <span className="text-white text-base font-normal">
                            Old interface
                          </span>
                          <svg
                            className="h-5"
                            viewBox="0 0 46 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 14C1 6.82 6.82 1 14 1h18c7.18 0 13 5.82 13 13s-5.82 13-13 13H14C6.82 27 1 21.18 1 14Z"
                              stroke="#fff"
                            ></path>
                            <circle cx="14" cy="14" r="9" fill="#fff"></circle>
                          </svg>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </header>
              <div className="flex flex-col flex-1 w-full max-w-desktop-login mt-7.5 sm:mt-0">
                <div className="flex flex-col">
                  <div className="grid grid-cols-3 gap-10 mt-5 lg:grid-cols-1 lg:gap-5 z-10 sm:px-5">
                    <div className="w-full">
                      <div className="flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base theme-card-bg">
                        <div className="flex items-center">
                          <span className="text-white text-xl sm:whitespace-nowrap">
                            Members in last 24 hours
                          </span>
                        </div>
                        <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                        {this.state.lastId}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base theme-card-bg">
                      <div className="flex items-center">
                        <span className="text-white text-xl sm:whitespace-nowrap">
                          Income in last 24 hours, TRX
                        </span>
                      </div>
                      <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                      {this.state.totalValue}
                      </span>
                    </div>
                    <div className="w-full">
                      <div className="flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base theme-card-bg">
                        <div className="flex items-center">
                          <span className="text-white text-xl sm:whitespace-nowrap">
                            Total Members
                          </span>
                        </div>
                        <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                        {this.state.totalMembers}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base theme-card-bg">
                      <div className="flex items-center">
                        <span className="text-white text-xl sm:whitespace-nowrap">
                          Total TRX Invested
                        </span>
                      </div>
                      <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                      {this.state.allTotalValue}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col mb-15 mt-15">
                    <div className="flex flex-col">
                      <div className="flex flex-col sm:px-5">
                        <span className="text-white text-3xl font-bold ">
                          Account preview
                        </span>
                        <span className="text-white-500 text-base mt-1 mb-7.5">
                          Look up any OxCash Pro member account in preview mode.
                          Enter ID to preview or click Demo to view a random
                          account.
                        </span>
                      </div>
                      <div className="flex sm:flex-col">
                        <div className="flex flex-col flex-1 sm:w-full bg-black-light rounded sm:rounded-none p-7.5 sm:p-5 mr-10 sm:mr-0 sm:mb-5 theme-card-bg">
                          <span className="text-white mb-3">Enter ID</span>
                          <div className="flex sm:flex-col">
                            <input onChange={(e) => this.setState({id: e.target.value})}
                              value={this.state.id}
                              className="w-full bg-white-100 border-2 border-transparent rounded-mini py-3 px-5 text-white outline-none focus:border-2 focus:border-black focus:bg-transparent flex-1 mr-5 sm:mr-0 sm:mb-3.5 py-2"
                              id="idbyPlan"
                              type="number"
                              placeholder="example: 13"
                            />
                            <button onClick={this.handleViewClick}
                            className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-blue-500 hover:bg-blue-700 active:bg-active-main-blue rounded-mini">
                              View
                            </button>
                          </div>
                        </div>
                        <div className="w-1/3 min-w-320px sm:w-full sm:px-5">
                          <div className="flex flex-col w-full rounded bg-black-light p-7.5 relative theme-card-bg">
                            <span className="text-white mb-3">
                              Connect wallet to Register or Login
                            </span>
                            
                              <button onClick={this.handleLogin} className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-main-bg hover:bg-hover-main-bg active:bg-active-main-bg sm:w-full">
                                Auto-Login
                              </button>

                            <img
                              src="img/favicon/apple-icon-120x120.png"
                              width="90"
                              className="sm:hidden absolute top-1/2 right-0 transform -translate-y-1/2"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="flex flex-col">
                      <div className="flex items-center sm:px-5">
                        <span className="text-white text-3xl font-bold sm:text-2xl">
                          Recent Activities
                        </span>
                      </div>
                      <div className="grid grid-cols-3 gap-10 mt-5 lg:grid-cols-1 lg:gap-0 z-10">
                        <div className="w-full overflow-hidden flex flex-col col-span-2 p-5 bg-gray rounded h-815px  lg:order-2 sm:rounded-none sm:p-5 sm:max-h-3/4">
                          <div className="flex flex-col flex-1 sm:overflow-auto">
                            {this.state.activities.map((a, index) => {
                              return (a.isRegistrationEvent ? 
                                  <div key={index} className="flex items-center justify-between py-5 border-line-gray border-b first:pt-0 w-full sm:py-5 sm:items-start">
                                    <div className="flex items-center sm:items-start justify-start sm:w-full">
                                      <div className="theme-card-bg flex w-10 h-10 items-center justify-center rounded-full flex-shrink-0 sm:w-7.5 sm:h-7.5">
                                        <svg
                                          className="fill-current text-white w-5 h-5"
                                          width="20"
                                          height="20"
                                          fill="#fff"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M7.5 9.167a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM2.5 17.5v-2.667A3.333 3.333 0 0 1 5.833 11.5h3.334a3.333 3.333 0 0 1 3.333 3.333V17.5"></path>
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M15.833 6.167a.5.5 0 0 1 .5.5v2h2a.5.5 0 1 1 0 1h-2v2a.5.5 0 1 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2a.5.5 0 0 1 .5-.5Z"
                                          ></path>
                                        </svg>
                                      </div>
                                      
                                      <div className="flex ml-5 items-center sm:w-full flex flex-wrap sm:ml-2.5">
                                        <a
                                          className="flex items-center justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                                          href="dashboard-user.html"
                                        >
                                          ID {a.id}
                                        </a>
                                        <div className="h-full flex flex-wrap justify-center items-center mx-2.5 sm:mx-1.5 ml-0">
                                          <span className="text-white-500 text-base sm:text-sm sm:leading-30px">
                                            new user joined
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex items-start">
                                      <div className="flex items-center justify-end whitespace-nowrap h-full">
                                        <a
                                          className="sm:order-2"
                                          target="_blank"
                                          href={"https://tronscan.org/#/transaction/" + a.txId}
                                        >
                                          <svg
                                            className="w-6 h-6"
                                            viewBox="0 0 24 24"
                                            fill="#fff"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M4.232 7.232A2.5 2.5 0 0 1 6 6.5h5a.5.5 0 0 1 0 1H6A1.5 1.5 0 0 0 4.5 9v9A1.5 1.5 0 0 0 6 19.5h9a1.5 1.5 0 0 0 1.5-1.5v-5a.5.5 0 0 1 1 0v5a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 18V9a2.5 2.5 0 0 1 .732-1.768Z"
                                            ></path>
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M20.354 3.646a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708-.708l10-10a.5.5 0 0 1 .708 0Z"
                                            ></path>
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M14.5 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V4.5H15a.5.5 0 0 1-.5-.5Z"
                                            ></path>
                                          </svg>
                                        </a>
                                        <span className="ml-2.5 text-white-500 text-base sm:text-sm sm:order-1 sm:ml-2.5 sm:mr-1 sm:leading-30px">
                                          {a.time}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  <div key={index} className="flex items-center justify-between py-5 border-line-gray border-b first:pt-0 w-full sm:py-5 sm:items-start">
                                    <div className="flex items-center sm:items-start justify-start sm:w-full">
                                      <div className="theme-card-bg flex w-10 h-10 items-center justify-center rounded-full flex-shrink-0 sm:w-7.5 sm:h-7.5">
                                        <svg
                                          className="fill-current text-white w-5 h-5"
                                          viewBox="0 0 20 20"
                                          fill="#ffff"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M3.468 3.468A2.167 2.167 0 0 1 5 2.833h8.334a1.333 1.333 0 0 1 1.333 1.334v2H15A1.333 1.333 0 0 1 16.334 7.5V10a.5.5 0 0 1-1 0V7.5A.333.333 0 0 0 15 7.167H5c-.417 0-.82-.12-1.167-.341V15A1.167 1.167 0 0 0 5 16.167h10a.333.333 0 0 0 .334-.334v-2.5a.5.5 0 0 1 1 0v2.5A1.333 1.333 0 0 1 15 17.168H5A2.166 2.166 0 0 1 2.833 15V5c0-.574.229-1.126.635-1.532ZM3.833 5A1.167 1.167 0 0 0 5 6.167h8.667v-2a.333.333 0 0 0-.333-.333H5A1.167 1.167 0 0 0 3.833 5Z"
                                          ></path>
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M5 3a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V5a2 2 0 0 0-2-2H5Z"
                                            fillOpacity=".5"
                                          ></path>
                                          <path d="M16.667 10v3.333h-3.334a1.667 1.667 0 0 1 0-3.333h3.334Z"></path>
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.333 10.5a1.167 1.167 0 1 0 0 2.333h2.834V10.5h-2.834Zm-1.532-.365a2.167 2.167 0 0 1 1.532-.635h3.334a.5.5 0 0 1 .5.5v3.333a.5.5 0 0 1-.5.5h-3.334a2.166 2.166 0 0 1-1.532-3.698Z"
                                          ></path>
                                        </svg>
                                      </div>
                                      <div className="flex ml-5 items-center sm:w-full flex flex-wrap sm:ml-2.5">
                                        <a
                                          className="flex items-center justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max false text-sm text-red-500"
                                          href="dashboard-user.html"
                                        >
                                          ID {a.id}
                                        </a>
                                        <div className="h-full flex flex-wrap justify-start items-center mx-2.5 sm:mx-1.5 false">
                                          <span className="text-white-500 text-base sm:text-sm sm:leading-20px">
                                            +
                                          </span>
                                          <span className="text-white text-base sm:text-sm mx-1 sm:leading-30px">
                                            {a.amount / 1000000} TRX{" "}
                                          </span>
                                          <span className="text-white-500 text-base sm:text-sm sm:leading-20px">
                                            in
                                            <span className=" text-orange">
                                              {" "}
                                              TRX{" "}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex items-start">
                                      <div className="flex items-center justify-end whitespace-nowrap h-full">
                                        <a
                                          className="sm:order-2"
                                          target="_blank"
                                          href={"https://tronscan.org/#/transaction/" + a.txId}
                                        >
                                          <svg
                                            className="w-6 h-6"
                                            viewBox="0 0 24 24"
                                            fill="#fff"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M4.232 7.232A2.5 2.5 0 0 1 6 6.5h5a.5.5 0 0 1 0 1H6A1.5 1.5 0 0 0 4.5 9v9A1.5 1.5 0 0 0 6 19.5h9a1.5 1.5 0 0 0 1.5-1.5v-5a.5.5 0 0 1 1 0v5a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 18V9a2.5 2.5 0 0 1 .732-1.768Z"
                                            ></path>
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M20.354 3.646a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708-.708l10-10a.5.5 0 0 1 .708 0Z"
                                            ></path>
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M14.5 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V4.5H15a.5.5 0 0 1-.5-.5Z"
                                            ></path>
                                          </svg>
                                        </a>
                                        <span className="ml-2.5 text-white-500 text-base sm:text-sm sm:order-1 sm:ml-2.5 sm:mr-1 sm:leading-30px">
                                          {a.time}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )
                            })}

                          </div>
                        </div>
                        <div className="flex flex-col space-y-10 lg:w-full lg:order-1 lg:mb-10 sm:mb-5 sm:space-y-5 sm:px-5">
                          <div className="bg-gray rounded p-5 flex flex-col flex-1 theme-card-bg">
                            <div className="flex justify-between items-center text-xl text-white">
                              <span>OxCash Pro Contracts</span>
                              <button className="rounded-full h-5 w-5 justify-center items-center bg-main-blue hidden">
                                <svg
                                  className="stroke-current text-white"
                                  width="8"
                                  height="4"
                                  fill="#fff"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M4 4 0 0h8L4 4Z"></path>
                                </svg>
                              </button>
                            </div>
                            <div className="flex flex-col flex-1 justify-between">
                              <div className="flex flex-col border-t border-b border-white-100 pb-2.5 mt-2.5">
                                <div className="flex justify-between items-center py-2.5 border-b border-white-100 space-y-1.5 last:border-0 last:pb-0">
                                  <span className="text-base text-white sm:text-sm">
                                    OxCash Pro
                                  </span>
                                  <div className="flex justify-end items-center space-x-2.5">
                                    <span className="text-base text-white sm:text-sm">
                                      TJpq...bMLg
                                    </span>
                                    {/* <button>
                                      <svg
                                        className="h-18px w-18px"
                                        viewBox="0 0 20 20"
                                        fill="#fff"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M15 6.667H8.332c-.92 0-1.667.746-1.667 1.666V15c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.746-1.666-1.667-1.666Z"></path>
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M3.469 3.468A2.167 2.167 0 0 1 5 2.833h6.666A2.167 2.167 0 0 1 13.834 5v1.667a.5.5 0 0 1-1 0V5a1.167 1.167 0 0 0-1.167-1.167H5.001A1.167 1.167 0 0 0 3.834 5v6.667a1.167 1.167 0 0 0 1.167 1.166h1.666a.5.5 0 1 1 0 1H5.001a2.167 2.167 0 0 1-2.167-2.166V5c0-.575.228-1.126.635-1.532Z"
                                        ></path>
                                      </svg>
                                    </button> */}
                                    <a
                                      target="_blank"
                                      href="https://tronscan.org/#/contract/TJpqgh8tLA1iFkG8xTSEMrBL1uL1zKbMLg/code"
                                    >
                                      <svg
                                        className="h-18px w-18px"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M11.314 3.813a3.446 3.446 0 1 1 4.873 4.874l-3.331 3.331a3.418 3.418 0 0 1-4.88-.001.5.5 0 0 1 .715-.7 2.417 2.417 0 0 0 3.452 0l.004-.004L15.48 7.98a2.446 2.446 0 1 0-3.46-3.46l-.416.417a.5.5 0 1 1-.707-.707l.417-.417Z"
                                          fill="#fff"
                                        ></path>
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M8.26 7.225a3.417 3.417 0 0 1 3.765.758.5.5 0 0 1-.715.7 2.417 2.417 0 0 0-3.452 0l-.003.004L4.52 12.02a2.446 2.446 0 0 0 3.46 3.46l.416-.417a.5.5 0 1 1 .708.707l-.417.417a3.446 3.446 0 1 1-4.874-4.874l3.332-3.332a3.417 3.417 0 0 1 1.115-.756Z"
                                          fill="#fff"
                                        ></path>
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="flex flex-col pt-2.5 mt-auto">
                                {/* <div className="flex flex-col py-2.5 border-b border-white-100 space-y-1.5 last:border-0 last:pb-0">
                                  <span className="text-base text-white">
                                    Transactions made
                                  </span>
                                  <span className="text-2xl text-white font-bold sm:text-xl">
                                    554274
                                  </span>
                                </div> */}
                                <div className="flex flex-col py-2.5 border-b border-white-100 space-y-1.5 last:border-0 last:pb-0">
                                  <span className="text-base text-white">
                                    Turnover, TRX
                                  </span>
                                  <span className="text-2xl text-white font-bold sm:text-xl">
                                  {this.state.totalValue}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="absolute left-1/2 -bottom-1/2 transform -translate-x-1/2 w-full h-full z-0 sm:hidden"></div>
                  </div>
                </div>
                <footer className="flex z-10  items-center  justify-between  py-10 w-full sm:justify-start sm:items-start sm:flex-col sm:px-5 sm:pt-7.5 sm:pb-12 sm:mt-0">
                  <div className="flex items-center sm:w-full sm:items-start sm:text-left sm:flex-col sm:order-2">
                    <span className="text-white-500 text-base font-normal mr-2.5 sm:text-sm sm:mb-2.5 sm:mr-0">
                      © 2022 All Rights Reserved
                    </span>
                  </div>
                  <div className="flex space-x-14 sm:w-full sm:space-y-14 sm:space-x-0 sm:order-1 sm:mb-7.5">
                    <div className="flex space-x-5 w-full">
                      <a
                        className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                        target="_blank"
                        href="https://t.me/oxcashnetwork"
                      >
                        <svg
                          className="w-3 h-3 sm:w-4 sm:h-4"
                          viewBox="0 0 14 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                            fill="#fff"
                          ></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
            <div className="Toastify"></div>
          </div>
        </header>
      </>
    );
  }
}

export default withWrapper(Login);
